import './breadcrumb.css';
export default {
  "breadcrumb": "pf-v5-c-breadcrumb",
  "breadcrumbDropdown": "pf-v5-c-breadcrumb__dropdown",
  "breadcrumbHeading": "pf-v5-c-breadcrumb__heading",
  "breadcrumbItem": "pf-v5-c-breadcrumb__item",
  "breadcrumbItemDivider": "pf-v5-c-breadcrumb__item-divider",
  "breadcrumbLink": "pf-v5-c-breadcrumb__link",
  "breadcrumbList": "pf-v5-c-breadcrumb__list",
  "dirRtl": "pf-v5-m-dir-rtl",
  "dropdownToggle": "pf-v5-c-dropdown__toggle",
  "modifiers": {
    "current": "pf-m-current"
  }
};